import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import BankAccount from "../../components/BankAccount";
import LoaderButton from "../../components/LoaderButton";
import PageLoader from "../../components/PageLoader";
import photo1 from "../../images/bankaccount.svg";
import FormImage from "../../layouts/formimage";
import { Constants } from "../../libs/Constants";
import { getList, update } from "../../libs/dbFunctions";
import { formatCurrency } from "../../libs/utils";

const BankInformation = (props) => {
  const [showAddBankAccount, setShowAddBankAccount] = useState(false);
  const [periodsPerAnnum, setPeriodsPerAnnum] = useState(2);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    function load() {
      getPlanDetail();
    }
    load();
    setLoading(false);
  }, [props.activeCompany]);
  const getPlanDetail = async () => {
    try {
      let planDetail = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        props.activeCompany
      );
      if (planDetail && planDetail.length > 0) {
        let purchasePeriods = 12 / Number(planDetail[0].purchasePeriod);
        setPeriodsPerAnnum(purchasePeriods);
        return;
      }
    } catch (e) {
      toast.error(e);
    }
  };
  const handleSuccess = async (response) => {
    setLoading(true);
    let details = response["_links"]["funding-source"]["href"].split("/");
    let saveFields = {
      ...props.userObj,
      bank_information: details[details.length - 1],
    };
    toast.success("Account added successfully");

    //update the userObj with salary and flags
    try {
      await update(Constants.dbTypes.USER, saveFields);
      await props.refreshUser();
      setLoading(false);
      if (
        props.userObj.accounts.length > 0 &&
        props.userObj.accounts.find(
          (account) => account.status === "unverified"
        )
      ) {
        props.history.push("/");
      } else {
        window.location.href = "/onboardingcomplete";
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  };
  return (
    <PageLoader isActive={loading}>
      <FormImage
        title="Automatic Deposits"
        subtitle="We’ll offset the money taken out for your ESPP and deposit it right into your bank alongside your paycheck."
        image={photo1}
        bgClass="background-blue"
      >
        <h2 className="text-center pb-3">Bank Information</h2>

        <div className="font-secondary text-center">
          We will be transferring the total amount of the annual loan (
          {formatCurrency(props.userObj?.contributionAmount * periodsPerAnnum)})
          as bi-monthly installments of{" "}
          {formatCurrency(
            (props.userObj?.contributionAmount * periodsPerAnnum) / 24
          )}
          . Where would you like this to be deposited?{" "}
          {
            <OverlayTrigger
              placement={"bottom"}
              delay={{ show: 150, hide: 250 }}
              overlay={
                <Tooltip style={{ zIndex: 9999999999 }}>
                  This is the bank account we will deposit money into, as well
                  as the account we will be paid back from.
                </Tooltip>
              }
            ><span>
                <FaInfoCircle
                  style={{
                    marginLeft: "5px",
                  }}
                />
              </span>

            </OverlayTrigger>
          }
        </div>
        <LoaderButton
          block
          type="submit"
          variant="primary"
          size="lg"
          text="Next"
          className="my-4"
          onClick={() => setShowAddBankAccount(true)}
        >
          Connect your Bank Account
        </LoaderButton>
        {showAddBankAccount && (
          <BankAccount
            show={showAddBankAccount}
            onHide={(result, response) => {
              setShowAddBankAccount(false);
              if (response) {
                if (!result) {
                  toast.error(response);
                } else {
                  handleSuccess(response);
                }
              }
            }}
            userObj={props.userObj}
            props={props}
          ></BankAccount>
        )}
      </FormImage>
    </PageLoader>
  );
};

export default BankInformation;
